import { observable, action, makeObservable } from "mobx";
import { TreeNodeItem } from "../components/tree-select/TreeSelect";

export default class LocationSelectorStore {
  public locationList: TreeNodeItem[] = [];
  public indexedLocationList: any;
  public selectedIds: string[] = [];
  public selectedRoomList: TreeNodeItem[] = [];
  public requestIds: number[] = [];
  public initialized: boolean = false;

  constructor() {
    makeObservable(this, {
      locationList: observable,
      indexedLocationList: observable,
      selectedIds: observable,
      selectedRoomList: observable,
      requestIds: observable,
      initialized: observable,

      setLocationList: action,
      setIndexedLocationList: action,
      setSelectedIds: action,
      setRequestIds: action,
      setInitialized: action,
    });
  }

  public setLocationList = (list: any[]) => {
    this.locationList = [...list];
  };

  public setIndexedLocationList = (list: any) => {
    this.indexedLocationList = list;
  };

  public setSelectedIds = (list: any[]) => {
    this.selectedIds = [...list];
  };

  public setRequestIds = (list: any[]) => {
    this.requestIds = [...list];
  };

  public setSelectedRoomList = (list: any[]) => {
    this.selectedRoomList = [...list];
  };

  public setInitialized = (value: boolean) => {
    this.initialized = value;
  };
}
